import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IAccessoryList, IComment, IOrder, VehicleReserveStatus } from 'next-common';

interface OrderState {
  order: IOrder;
  isRefetching?: boolean;
}

const initialState: OrderState = {
  order: null,
  isRefetching: false,
};

const orderSlice = createSlice({
  name: 'order',
  initialState,
  reducers: {
    setOrder: (state, action: PayloadAction<IOrder>) => {
      state.order = action.payload;
    },
    updateReserveStatus: (state, action: PayloadAction<VehicleReserveStatus>) => {
      if (state.order && state.order.reserveDetails) {
        state.order.reserveDetails.vehicleReserveStatus = VehicleReserveStatus[
          action.payload
        ] as unknown as VehicleReserveStatus;
      }
    },
    setComments: (state, action: PayloadAction<IComment[]>) => {
      if (state.order) {
        state.order.comments = action.payload;
      }
    },
    setOrderRammeavtaleAccessories: (state, action: PayloadAction<IAccessoryList[]>) => {
      state.order.rammeavtale.accessories = action.payload;
    },
    setIsOrderRefetching: (state, action: PayloadAction<boolean>) => {
      state.isRefetching = action.payload;
    },
  },
});

export const { setOrder, updateReserveStatus, setComments, setOrderRammeavtaleAccessories, setIsOrderRefetching } =
  orderSlice.actions;
export default orderSlice.reducer;
